<template>
  <OnboardingLayout
    title="Upload Contract"
    description="Join thousands of Arnergy users all over Africa who are enjoying uninterrupted power supply with our solar solution."
    @onButtonClick="updateDBData"
    imageDescription="System ownership is transferred upon meeting all lease obligations"
    :imageUrl="require('@/assets/img/female-wave.gif')"
    :canContinue="canContinue"
    :loading="showLoading"
  >
    <div class="summary-container">
      <div class="summary">
        <!-- <div v-if="showLoading" style="margin-bottom: 20px">
          <vue-skeleton-loader noOfCell="2"></vue-skeleton-loader>
        </div> -->

        <div v-show="htmlContent">
          <!-- <div style="margin-bottom: 20px">
            We have generated a contract for you, kindly
            <a
              :href="pdf_url"
              download="contract.pdf"
              style="text-decoration: underline"
              target="_blank"
              >click here to download</a
            >.
          </div> -->

          <div
            id="pdf-reader"
            v-html="htmlContent"
            class="pdf-reader"
            title="Contract"
            @scroll="checkScrollEnd"
          ></div>
          <div class="acknowledge-style form-check">
            <input
              :disabled="!isScrolledToEnd"
              class="form-check-input"
              id="styledCheckbox"
              type="checkbox"
              name="acknowledge"
              v-model="acknowledged"
              @click="handleAcknowledgement"
            />
            <label class="form-check-label" for="styledCheckbox">
              I hereby acknowledge this contract
            </label>
          </div>
          <!-- <a-upload
            :action="uploadUrl"
            @change="handleChange"
            @drop="handleDrop"
            accept="application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          >
            <a-button> <a-icon type="upload" /> Click to Upload </a-button>
          </a-upload> -->
        </div>

        <div v-show="!htmlContent">
          Unable to generate your PDF contract, please try again.
        </div>
      </div>
    </div>
  </OnboardingLayout>
</template>

<script>
import VueSkeletonLoader from "@/components/SkeletonLoader.vue";
import OnboardingLayout from "@/components/layouts/onboarding-layout.vue";
import CalculatorService from "@/services/calculator.js";
import { ONBOARDING_URL } from "@/utils/http-common.js";
import { Button, Checkbox, Icon, message, Upload } from "ant-design-vue";
import axios from "axios";
import { Form, FormItem } from "element-ui";
import { mapGetters } from "vuex";

export default {
  components: {
    OnboardingLayout,
    VueSkeletonLoader,
    "el-form": Form,
    "el-form-item": FormItem,
    "a-upload": Upload,
    "a-button": Button,
    "a-icon": Icon,
  },
  computed: {
    ...mapGetters(["getUserSession"]),
        isFixedRateLocation() {
      return fixedRateLocations.some(
        (location) => location.key === this.$store.state.onboardingCustomerState.customerRegion
      );
    },
  },
  watch: {
    quantity(newValues, oldValues) {
      if (!newValues) return;
      // this.selectedProduct = {
      //   firstPaymentAmt: 3 * +this.loAmount * newValues,
      //   cautionFee: +this.loAmount * newValues,
      //   monthlyPaymentValue: +this.loAmount * newValues
      // };
    },
  },
  data() {
    return {
      LVI_REGIONS: ["lekki", "victoria_island", "ikoyi"],
      url: "https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf",
      showLoading: false,
      canContinue: false,
      acknowledged: false,
      isScrolledToEnd: false,
      nextPageName: "",
      formData: {
        numInverters: 1,
        customerAddress: "",
        buildingType: "",
      },
      pdf_url: "",
      uploaded_pdf_url: "",
      htmlContent: "",
      selectedProduct: {},
      uploadUrl: `${ONBOARDING_URL}/kycfiles/s3-file-upload`,
    };
  },
  methods: {
    checkScrollEnd(event) {
      const element = event.target;
      const scrollTop = element.scrollTop; // Distance from the top
      const scrollHeight = element.scrollHeight; // Total height of the content
      const clientHeight = element.clientHeight; // Visible height of the element

      // Check if scrolled to the bottom
      this.isScrolledToEnd = scrollTop + clientHeight >= scrollHeight - 1; // Use `-1` to handle rounding issues
    },
    async handleContinue() {
      //     console.log({pdf_url: this.pdf_url})
      //   if (!this.pdf_url) {
      //     return;
      //   }
      //   this.updateGlobalState();
    },
    async updateDBData() {
      const state = await this.getCurrentState();
      const { customerRegion, referralname } = state;
      const isLVIRegion = this.LVI_REGIONS.includes(
        customerRegion.toLowerCase()
      );
      const shouldSkipPayment = (
        isLVIRegion &&
        (!referralname || referralname.toLowerCase() !== 'sunfi')
      );

      if (isLVIRegion && shouldSkipPayment) {
        this.nextPageName = "AwaitingContract";
      } else {
        this.nextPageName = "OnboardPaymentDeposit";
      }

      try {
        this.showLoading = true;
        const res = await CalculatorService.uploadContract({
          contract: this.uploaded_pdf_url,
          status: "pending",
        });
        console.log({ res });
        if (res) {

          this.showLoading = false;
          this.navTo(this.nextPageName);
        }
      } catch (error) {
        this.showLoading = false;
        console.error("Error: ", error);
      }
    },
    handleUploadContract(pdf_url) {
      axios
        .post(`${ONBOARDING_URL}/kycfiles/s3-file-upload`, pdf_url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
          },
        })
        .then((res) => {
          this.uploaded_pdf_url = res.data.url;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async handleAcknowledgement() {
      this.acknowledged = !this.acknowledged;
      const state = this.$store.state.onboardingCustomerState;
      const selectedProduct = state.selectedProduct;
      const acknowledgement = this.acknowledged;
      const {id} = await this.getCurrentState();

      let url = "/kycfiles/generate-ipp-contract";
      if (this.acknowledged === true) {
        this.showLoading = true;
        axios
          .post(
            `${ONBOARDING_URL}${url}`,
            {
              arnergyProductId: selectedProduct.id || state.product_id,
              onboardStateId: id,
              acknowledgement: acknowledgement,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
              },
            }
          )
          .then(async (res) => {
            this.pdf_url = res.data.pdf_path;
            this.htmlContent = res.data.html_content;

            // fetch the pdf
            const response = await fetch(res.data.pdf_path);
            const blob = await response.blob();
            const randomuuid = crypto.randomUUID();

            const file = new File(
              [blob],
              `uploaded-document${randomuuid}.pdf`,
              {
                type: "application/pdf",
              }
            );
            const formData = new FormData();
            formData.append("file", file);
            this.handleUploadContract(formData);
            this.showLoading = false;
            // this.uploaded_pdf_url = res.data.pdf_path;
            this.canContinue = true;
            // this.navTo("OnboardUploadContract");
          })
          .catch((error) => {
            console.error("Unexpected error during request: ", error);
            this.showLoading = false;
          });
      } else {
        this.canContinue = false;
        this.showLoading = true;
        axios
          .post(
            `${ONBOARDING_URL}${url}`,
            {
              arnergyProductId: selectedProduct.id || state.product_id,
              onboardStateId: state.id,
              acknowledgement: acknowledgement,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
              },
            }
          )
          .then((res) => {
            this.pdf_url = res.data.pdf_path;
            this.showLoading = false;
            // this.navTo("OnboardUploadContract");
          })
          .catch((error) => {
            console.error("Unexpected error during request: ", error);
            this.showLoading = false;
          });
      }
    },
    handleChange(info) {
      const status = info.file.status;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        this.uploaded_pdf_url = info.file.response.url;
        this.canContinue = true;
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    handleDrop(e) {
      console.log(e);
    },
    async generateContract() {
      let url = "";
      const state = this.$store.state.onboardingCustomerState;
      const selectedProduct = state.selectedProduct;
      const acknowledgement = this.acknowledged;
      const {id} = await this.getCurrentState();

      switch (
        state.paymentType.toLowerCase() ||
        state.packagetype.toLowerCase()
      ) {
        case "ipp":
          url = "/kycfiles/generate-ipp-contract";
          break;
        case "lo":
          url = "/kycfiles/generate-lo-contract";
          break;
        case "os":
          url = "/kycfiles/generate-os-contract";
          break;

        default:
          break;
      }

      this.showLoading = true;
      axios
        .post(
          `${ONBOARDING_URL}${url}`,
          {
            arnergyProductId: selectedProduct.id || state.product_id,
            onboardStateId: id,
            acknowledgement: acknowledgement,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
            },
          }
        )
        .then((res) => {
          this.pdf_url = res.data.pdf_path;
          this.htmlContent = res.data.html_content;
          this.showLoading = false;
          // this.navTo("OnboardUploadContract");
        })
        .catch((error) => {
          console.error("Unexpected error during request: ", error);
          this.showLoading = false;
        });
    },

    async getCurrentState() {
      const HTTP = this.$httpUtils.FASTHTTP;
      const url = "/onboardingstate/state";
      try {
        const response = await HTTP.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
          },
        });
        console.log("response.data", response.data);
        return response.data;
      } catch (error) {
        console.log({ error });
      }
    },
  },

  async mounted() {
    // this.paymentType = this.$store.state.onboardingCustomerState.paymentType;
    this.generateContract();
    await this.getCurrentState();
  },
};
</script>

<style lang="scss" scoped>
h1,
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

.downPayment {
  width: 102% !important;
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
  }
}
.tenureMonth {
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
  }
}

.buildingType {
  width: 102% !important;
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
  }
}

.address {
  width: 102% !important;
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
    // font-weight: normal;
  }
}

.quantity label {
  font-size: 16px;
  color: #727272;
  // font-weight: normal;
}
.quantity input {
  width: 50px;
  border-radius: 6px;
  height: 30px;
  margin-left: 6px;
  border: 1px solid #d3d9dd;
}

p {
  color: #727272;
  font-size: 16px;
  line-height: 24px;
}

h2 {
  color: #0892d0;
  margin-bottom: 18px;
}

.summary-container {
  width: 100%;
  max-width: 527px;
}

.summary {
  // width: 55%;

  h2 {
    color: #0892d0;
    margin-bottom: 30px;
    font-weight: 700;
  }

  > div {
    width: 100%;
  }

  .summary-table {
    padding: 0px 28px;
    background: #fafafa;

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 17px 0px;
      border-bottom: 1px dashed #e8e2e2;

      p {
        color: #000000;
        font-size: 16px;
      }

      p:last-child {
        text-align: right;
        width: 30%;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    .bold-text p {
      font-weight: bold;
    }

    .tabbed {
      position: relative;
    }

    .tabbed p {
      margin-left: 55px;
    }

    .tabbed .arrows {
      position: absolute;
      bottom: 30px;
      left: 25px;
    }
  }

  .tenure-section {
    margin-bottom: 30px;

    h4 {
      color: #fe7a11;
      margin-bottom: 10px;
      font-weight: bold;
    }

    .tenure-bar {
      display: flex;
      justify-content: space-between;

      .point {
        text-align: center;
        position: relative;
        width: 15px;
        overflow-x: visible;
        cursor: pointer;

        &:first-child {
          cursor: text;
        }

        &:last-child {
          text-align: right;
        }

        p {
          color: #efefef;
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 2px;
          height: 20px;
        }

        div {
          width: 3px;
          height: 8px;
          border-radius: 2px;
          background: #efefef;
          display: inline-block;
        }

        div.active {
          background: #ace5ff;
        }

        p.marked {
          padding: 2px 8px;
          border-radius: 5px;
          background: #0892d0;
          width: 80px;
          margin-left: -32.5px;
        }

        div.marked {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #0892d0;
        }
      }
    }

    .base-line {
      background: #efefef;
      height: 5px;
      border-radius: 9px;
      margin-top: -14px;

      .blue-line {
        width: 82.5%;
        height: 5px;
        background: #ace5ff;
        border-radius: 9px;
      }
    }
  }
}

.illustration {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 350px;

  img:first-child {
    margin-bottom: -3rem;
    z-index: 3;
  }
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}

.acknowledge-style {
  justify-content: center !important;
  align-items: center !important;
  margin-top: 8px;
}

.pdf-reader {
  border: 1px solid #666ccc;
  border-radius: 10px;
  height: 400px;
  padding: 20px;
  overflow-y: scroll;
}

@media only screen and (max-width: 700px) {
  .pdf-reader {
    width: 100% !important;
  }
}

@media only screen and (min-width: 701px) {
  .pdf-reader {
    width: 800px !important;
  }
}

/* Customize scrollbar size */
.pdf-reader::-webkit-scrollbar {
  width: 16px; /* Increase width for vertical scrollbar */
  height: 16px; /* Increase height for horizontal scrollbar */
}

.pdf-reader::-webkit-scrollbar-thumb {
  background-color: #888; /* Scrollbar thumb color */
  border-radius: 8px; /* Rounded corners */
}

.pdf-reader::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* Scrollbar track color */
  border-radius: 8px; /* Rounded corners */
}

/* Optional: Hover effect for the scrollbar thumb */
.pdf-reader::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/contract-upload/index.vue